import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-sound-Mute",
  "use": "rt-base-sound-Mute-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-sound-Mute\"><path d=\"M599.104 476.053v313.472c0 43.627-53.867 64.79-84.053 33.024L377.856 697.28l221.227-221.227z m183.68-183.701a308.885 308.885 0 0 1 111.957 211.2v56.043c-9.45 105.472-71.85 195.69-160.426 243.882l-29.547-56.789A245.27 245.27 0 0 0 832 531.584a244.907 244.907 0 0 0-94.72-193.685l45.525-45.547z m-94.933-55.893l45.269 45.248-482.73 482.709-45.249-45.227 482.71-482.73z m10.09 140.757a191.467 191.467 0 0 1 69.376 147.84 191.467 191.467 0 0 1-92.416 164.224l-29.653-56.96a127.488 127.488 0 0 0 58.07-107.243c0-41.962-20.054-79.146-50.945-102.293l45.568-45.568z m-98.837-133.76v21.419L175.765 688.213a64 64 0 0 1-36.373-57.749V416.981a64 64 0 0 1 60.224-63.893l4.31-0.107 172.97 2.88 138.176-145.45c30.165-31.787 84.053-10.603 84.053 33.024z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/sound-Mute.svg
// module id = 1750
// module chunks = 228